export const AdsTable = [
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'XYZ Entertainment',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
  { 
    name: 'Orokii',
    price: '1000.00',
    stats: 'Campaign off',
    strategy: 'Conversions',
  },
]